import { i18next } from '@yola/ws-sdk';

const createDownloadValidator = () => (value) => {
  if (!value) {
    return i18next.t('You need to attach a file');
  }

  return null;
};

export default createDownloadValidator;
